<template>
  <div class="sortable-column-header">
    <span>{{ label }}</span>
    <span class="sort-icons">
      <i
          class="el-icon-caret-top"
          :class="{ active: sortDirection === 'asc' }"
          @click="toggleSort('asc')"
      ></i>
      <i
          class="el-icon-caret-bottom"
          :class="{ active: sortDirection === 'desc' }"
          @click="toggleSort('desc')"
      ></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SortableColumnHeader',
  props: {
    label: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    currentSort: {
      type: Object,
      default: () => ({ field: null, direction: null })
    },
    defaultDirection: {
      type: String,
      default: 'desc',
      validator: (value) => ['asc', 'desc'].includes(value)
    },
    defaultActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localSort: {
        field: this.defaultActive ? this.field : null,
        direction: this.defaultActive ? this.defaultDirection : null
      }
    }
  },
  computed: {
    sortActive () {
      return this.currentSort.field === this.field
    },
    sortDirection () {
      return this.sortActive ? this.currentSort.direction : null
    }
  },
  mounted () {
    // Si cette colonne doit être active par défaut, émettre l'événement de tri
    if (this.defaultActive) {
      this.$emit('sort', {
        field: this.field,
        direction: this.defaultDirection
      })
    }
  },
  methods: {
    toggleSort (direction) {
      // Si déjà actif dans cette direction, désactiver le tri
      if (this.sortActive && this.sortDirection === direction) {
        this.$emit('sort', { field: null, direction: null })
      } else {
        // Sinon, activer le tri dans la direction cliquée
        this.$emit('sort', {
          field: this.field,
          direction: direction
        })
      }
    }
  }
}
</script>

<style scoped>
.sortable-column-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.sort-icons {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
}

.sort-icons i {
  font-size: 18px;
  color: #C0C4CC;
  line-height: 0.8;
  cursor: pointer;
}

.sort-icons i.active {
  color: #0ab1bf;
}
</style>
